var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIwocaLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.186 0H1.814A1.8 1.8 0 0 0 0 1.818l.012 28.364a1.8 1.8 0 0 0 1.813 1.817h28.436c1.015 0 1.764-.76 1.738-1.777V1.818A1.815 1.815 0 0 0 30.186 0Zm-2.25 27.936H4.063V4.029l23.873.051v23.856Zm-8.721-7.26 3.273 1.296c.242.091.511-.052.511-.324V10.355c0-.26-.269-.428-.511-.324l-3.273 1.322a.372.372 0 0 0-.215.35v8.662c0 .13.067.246.215.31Zm-6.43.003-3.273 1.296c-.243.09-.512-.078-.512-.337v-11.29c0-.246.27-.414.512-.323l3.272 1.322a.372.372 0 0 1 .216.35v8.658c0 .142-.067.272-.216.324Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIwocaLogoWhite);
export default __webpack_public_path__ + "static/media/iwocaLogoWhite.909ea5fa68a30d218d9f7d4ac27d51e4.svg";
export { ForwardRef as ReactComponent };